import { Skeleton } from "@/components/ui/skeleton"
import { ProductCardSkeleton } from "~/components/shared/product-card/skeleton"

const FEATURED_SECTIONS_COUNT = 3
const FEATURED_PRODUCTS_COUNT = 4

export const FeaturedProductsSkeleton = () => {
  return (
    <>
      {Array.from({ length: FEATURED_SECTIONS_COUNT }).map(
        (_, sectionIndex) => (
          <section
            aria-label='Produtos em destaque'
            className='w-full py-8'
            // biome-ignore lint/suspicious/noArrayIndexKey: <list> Skeleton only
            key={sectionIndex}
          >
            <div className='mx-auto max-w-7xl px-4 sm:px-6 lg:px-8'>
              <div className='flex items-center justify-between'>
                <Skeleton className='h-7 w-48' />
                <Skeleton className='h-5 w-20' />
              </div>

              <div className='mt-8 flex gap-4 overflow-hidden'>
                {Array.from({ length: FEATURED_PRODUCTS_COUNT }).map(
                  (_, productIndex) => (
                    // biome-ignore lint/suspicious/noArrayIndexKey: <list> Skeleton only
                    <ProductCardSkeleton key={productIndex} />
                  )
                )}
              </div>
            </div>
          </section>
        )
      )}
    </>
  )
}
